var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.778,
    height: 15,
    viewBox: "0 0 17.778 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "message",
    d: "M12.62,0a5.193,5.193,0,0,1,5.158,5.2h0V6.5l-.006.086a.631.631,0,0,1-.623.548h0l-.008-.016-.1-.008a.628.628,0,0,1-.346-.178.636.636,0,0,1-.184-.448h0V5.2A3.946,3.946,0,0,0,12.62,1.275H5.158A3.946,3.946,0,0,0,1.266,5.2h0V9.8a3.946,3.946,0,0,0,3.892,3.921H12.62A3.946,3.946,0,0,0,16.512,9.8a.636.636,0,0,1,1.266,0A5.193,5.193,0,0,1,12.62,15H5.158A5.185,5.185,0,0,1,0,9.8H0V5.2A5.177,5.177,0,0,1,5.158,0H12.62Z",
    fill: "#8d8d8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallets);
export default __webpack_public_path__ + "static/media/wallets.3895461ba72d67b46ec60cf52d9079d9.svg";
export { ForwardRef as ReactComponent };